// extracted by mini-css-extract-plugin
module.exports = {"container":"stock-transfer-requests_container__MEA4Y"};